import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ActionsType } from './types'
import contractExample from '../../../../features/opportunities/assets/Trendsetter_contract_example.pdf?url'

export const PreviewContract = ({ contract, ...props }: ActionsType) => {
  const { t } = useLocales()

  // PDF files can be displayed directly in iframe
  const pdfUrl = `${contractExample}#toolbar=0`

  return (
    <Modal
      width={900}
      title={
        contract
          ? `${t('generic.preview')} - ${contract.contract_number}`
          : t('generic.preview')
      }
      cancelButtonProps={{ hidden: true }}
      okText={t('buttons.close') || t('buttons.cancel')}
      onOk={props.onCancel}
      {...props}
    >
      <iframe
        title="contract-preview"
        width="100%"
        height="820px"
        loading="lazy"
        src={pdfUrl}
        allowFullScreen
      />
    </Modal>
  )
}
